import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { Button } from 'reactstrap';
import PrintOfficialReceipt from './printOfficialReceipt';

const PrintTransaction = ({ selectedData }) => {
  const printRef = useRef();

  return (
    <>
      <ReactToPrint
        trigger={() => {
          return (
            <Button size='sm'>
              <i className='fa fa-print' />
            </Button>
          );
        }}
        content={() => printRef.current}
        pageStyle={`
          @page { 
            size: A5 portrait; 
            margin: 10mm; 
          }
          @media print {
            body { 
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
        `}
      />
      <div id='print' style={{ display: 'none' }}>
        <PrintOfficialReceipt ref={printRef} data={selectedData} />
      </div>
    </>
  );
};

export default PrintTransaction;
